const queryKeys = {
  comments: (entityType, entityId) => ['comments', entityType, entityId],
};

export default queryKeys;
